var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "我需要这类客户",
        visible: _vm.show,
        center: "",
        width: "586px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            {
              staticStyle: { height: "40px", "line-height": "40px" },
              attrs: { span: 3 },
            },
            [_vm._v("关键词")]
          ),
          _c(
            "el-col",
            { staticClass: "keyword", attrs: { span: 20 } },
            [
              _c("el-input", {
                attrs: { maxlength: 30, placeholder: "输入关键词" },
                model: {
                  value: _vm.word,
                  callback: function ($$v) {
                    _vm.word = $$v
                  },
                  expression: "word",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 3 } }, [_vm._v(" ")]),
          _c(
            "el-col",
            {
              staticClass: "mt-5 tal",
              staticStyle: { color: "#666666" },
              attrs: { span: 20 },
            },
            [_vm._v("*添加与需要客户相关的关键词，提升推荐准确度")]
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.show = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.clickSearch } },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }